module.exports = __webpack_public_path__ + "static/media/dieta.e9286a3a.png";